import { ArrowRight, Person } from "@mui/icons-material"
import { Grid, Paper, Typography, Box, IconButton, Button } from "@mui/material"
type GenericChipProps = {
    title: string | React.ReactNode,
    subtitle: string | React.ReactNode,
    icon: React.ReactNode,
    testOrAction?: string,
    onClick?: () => void,
    subAction?: string
    dataTour?: string,
}
const GenericChip = (props: GenericChipProps) => {
    return (
        <Paper data-tour={props.dataTour} sx={{ display: "flex", alignItems: "center", padding: ".5rem", height: 125, boxSizing: "border-box", overflow: "hidden" }}>
            <Box >
                <Box sx={{ display: "flex", alignItems: "center", width: "100%", minWidth: 0 }}>
                    <Box sx={{ paddingRight: "10px", flexShrink: 0 }}>
                        {props.icon}
                    </Box>
                    <Box sx={{ minWidth: 0, flex: 1 }}>
                        <Typography sx={{ fontSize: "16px" }}>{props.title}</Typography>
                        <Typography >{props.subtitle}</Typography>
                        {props.onClick ? (
                            <Box sx={{ display: "flex" }}>
                                <Button
                                    data-tour={`${props.dataTour}${props.subAction}`}
                                    sx={{ fontSize: "14px" }}
                                    onClick={props.onClick}
                                    endIcon={<ArrowRight />}>
                                    {props.testOrAction}
                                </Button>
                            </Box>
                        ) : (
                            <Box sx={{ display: "flex" }}>
                                <Typography color={props.testOrAction?.includes("-") ? "red" : parseInt(props.testOrAction!) > 0 ? "main" : "main"}
                                    sx={{ fontSize: "18px", padding: "8px 6px", }}>{props.testOrAction}</Typography>
                            </Box>
                        )}
                    </Box>
                </Box>



            </Box>

        </Paper>
    )
}
export default GenericChip